import React, { useEffect, useState } from "react";
import PartnerSummaryClientDetail from "./PartnerSummaryClientDetail";
import PartnerBrokerageTable from "./PartnerBrokerageTable";
import PartnerClientSummary from "./PartnerClientSummary";
import PartnerNetEquityPortfolio from "./PartnerNetEquityPortfolio";
import PartnerTradingTransaction from "./PartnerTradingTransaction";
import PartnerMarginDetails from "./PartnerMarginDetails";
import PartnerAnalyticNew from "./PartnerAnalyticNew";
import PartnerPayinPayout from "./PartnerPayinPayout";
import PartnerDividendInfo from "./PartnerDividendInfo";
import PartnerIpoInfo from "./PartnerIpoInfo";
import PartnerPortfolioOverviewGainers from "./PartnerPortfolioOverviewGainers";
import PartnerPortfolioOverviewLooser from "./PartnerPortfolioOverviewLooser";
import PartnerIncPortfolioNew from "./PartnerIncPortfolioNew";
import PartnerInvestmentSnapshot from "./PartnerInvestmentSnapshot";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { AESEncryption, ApiResDecrypt, decryptData } from "../../../CommonMethhods/CommonMethods";
import { DASHBOARD_CLIENT_DETAIL_EQUITY, DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import PartnerHoldingsNetPosition from "../PartnerAdminOnboardingComponent/PartnerHoldingNetPosition/PartnerHoldingsNetPosition";
import { axiosSsoJsonReserv1 } from "../../../CommonMethhods/axiosPartnerInterceptor";

function PartnerDetailsEquity(props) {
  const PartnerClientCode = localStorage.getItem("ClientId2");
  const storeToken = localStorage.getItem("ssoToken");
  const [investEquity, setInvestEquity] = useState();
  const [risk, setRisk] = useState();
  const [netPortfolio, setNetPortfolio] = useState();
  const [netEquityLoader, setNetEquityLoader] = useState(true);
  const [portAnalysis, setPortAnalysis] = useState();
  const [smallLoader, setSmallLoader] = useState(false);

  const getPortAnalysisDetails = async (clientCode) => {
    setSmallLoader(true);
    let payloadValue = { clientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getAnalysis = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_OVERVIEW.PortfolioAnalysis_URL,
        `"${encPayload}"`,
      );
      const response = ApiResDecrypt(getAnalysis?.data);
      const res = response.data;
      setPortAnalysis(res);
      setSmallLoader(false);
    } catch (error) {
      console.log(error);
      setSmallLoader(false);
      setSmallLoader(false);
    }
  };

  const getInvestEquityDetails = async (clientCode) => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getEquity = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.InvestmentSnapshot_URL + clientCode,
        `"${encPayload}"`,
      );
      const response2 = ApiResDecrypt(getEquity?.data);
      const res1 = response2.data;
      setInvestEquity(res1);  
      setRisk(res1.riskProfile);
      setNetPortfolio(res1.portfolio);
      setNetEquityLoader(false);
    } catch (error) {
      console.log(error);
      setNetEquityLoader(false);
    }
  };
  useEffect(() => {
    let clientCode = "";
    if (PartnerClientCode) {
      clientCode = PartnerClientCode;
      getInvestEquityDetails(clientCode);
      getPortAnalysisDetails(clientCode);
    }
  }, []);
  
  return (
    <>
      <PartnerInvestmentSnapshot
      investmentSnapshot={
        investEquity === undefined || null ? "-" : investEquity
      }
      loader={smallLoader} 
      />

      <PartnerSummaryClientDetail />
      <PartnerBrokerageTable />

      <div className="row bottom-25">

        <PartnerClientSummary />

        <PartnerNetEquityPortfolio
          netEquityPortfolio={
            netPortfolio === undefined || null ? "-" : netPortfolio
          }
          netEquityLoader={netEquityLoader}
        />
      </div>

      <PartnerTradingTransaction />
      <PartnerHoldingsNetPosition />

      {/* <!-- equity slider --> */}
      <div className="row bottom-25">
        {/* <PartnerEquityPortfolioAnalysis /> */}
        <PartnerMarginDetails />
      </div>

      {/* <!-- analytics section --> */}
      <PartnerAnalyticNew />

      {/* <!-- payin and pyout details and portfolio growth section --> */}
      <div className="row bottom-25">
        <PartnerPayinPayout />
      </div>
      {/* <!-- platform Dividend Ipo --> */}
      <div className="row bottom-25">
        {/* <PartnerPlatformWiseInfo /> */}

        <PartnerDividendInfo />
        <PartnerIpoInfo />
      </div>
      {/* <!-- gainners and loosers section --> */}
      <div className="row bottom-25">
        <PartnerPortfolioOverviewGainers />
        <PartnerPortfolioOverviewLooser />
      </div>
      <PartnerIncPortfolioNew />
    </>
  );
}

export default PartnerDetailsEquity;
